module.exports = __webpack_public_path__ + "static/bg-team-six-f9c1092d7ff5c622419146631e93b0bc.png";